import { EventEmitter } from '@angular/core';
import { DataService } from '../../../services/api/data.service';
import { SessionService } from '../../../services/session/session.service';
var TestEmailDialogComponent = /** @class */ (function () {
    function TestEmailDialogComponent(dataService, sessionService) {
        this.dataService = dataService;
        this.sessionService = sessionService;
        this.visibleValue = false;
        this.visibleChange = new EventEmitter();
        this.errorDialogVisible = false;
    }
    Object.defineProperty(TestEmailDialogComponent.prototype, "visible", {
        get: function () {
            return this.visibleValue;
        },
        set: function (value) {
            this.visibleValue = value;
            this.visibleChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    TestEmailDialogComponent.prototype.dialogAction = function (action) {
        var _this = this;
        if (action === 'Test') {
            var parameters = this.emails.replace(/\r?\n/g, ';');
            this.dataService.Backend_NotifyAdminsOfFailedEmails(parameters).subscribe(function (responses) {
                if (responses && responses.length > 0) {
                    _this.failedMessage = _this.getResponseMessage(responses);
                    _this.errorDialogVisible = true;
                }
                else {
                    _this.close();
                }
            });
        }
        else {
            this.close();
        }
    };
    TestEmailDialogComponent.prototype.close = function () {
        this.errorDialogVisible = false;
        this.visible = false;
        this.emails = undefined;
    };
    TestEmailDialogComponent.prototype.getResponseMessage = function (responses) {
        var result = '';
        if (responses) {
            responses.forEach(function (message) {
                result += message + '<br/>';
            });
        }
        return result;
    };
    return TestEmailDialogComponent;
}());
export { TestEmailDialogComponent };
